<div>
	<app-breadcrumbs [selectedClient]="selectedClient()"></app-breadcrumbs>
</div>
<nz-card>
	@if (!selectedClient()) {
		<app-client-selector (onSelect)="onSelectClient($event)"></app-client-selector>
	} @else {
		<button nz-button nzType="link" class="change-client-button" (click)="onChangeClient()">
			← Change Client ({{ selectedClient()?.active_text?.name || 'Missing active text...' }})
		</button>

		<app-stride-algorithm-report-filter-form
			[clientUuid]="selectedClient()?.uuid"
			(onStudentSelected)="onStudentSelected($event)"
		></app-stride-algorithm-report-filter-form>
	}
</nz-card>

@if (selectedClient() && selectedStudentUuid()) {
	<nz-card nzTitle="Select an Activity / Take">
		<app-stride-log-activity-picker
			[clientUuid]="selectedClient()?.uuid"
			[studentUuid]="selectedStudentUuid()"
			(onSelect)="onActivitySelected($event)"
		></app-stride-log-activity-picker>
	</nz-card>
}

@if (selectedActivity()) {
	<nz-card nzTitle="User's Current Skill Levels">
		<app-stride-log-summary [summary]="summary()"></app-stride-log-summary>
	</nz-card>

	<nz-card [nzTitle]="'Decision History (' + totalCount() + ' step(s))'">
		<app-stride-algorithm-report [entries]="entries()"></app-stride-algorithm-report>
	</nz-card>
}

